function cov_eonn68ama() {
  var path = "/app/src/utils/check-currency.tsx";
  var hash = "b7dbc67a59ddc47d06b83426926cd65cdc3fd5c7";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/app/src/utils/check-currency.tsx",
    statementMap: {
      "0": {
        start: {
          line: 8,
          column: 29
        },
        end: {
          line: 13,
          column: 1
        }
      },
      "1": {
        start: {
          line: 9,
          column: 9
        },
        end: {
          line: 9,
          column: 52
        }
      },
      "2": {
        start: {
          line: 10,
          column: 9
        },
        end: {
          line: 10,
          column: 26
        }
      },
      "3": {
        start: {
          line: 15,
          column: 30
        },
        end: {
          line: 23,
          column: 1
        }
      },
      "4": {
        start: {
          line: 19,
          column: 9
        },
        end: {
          line: 19,
          column: 55
        }
      },
      "5": {
        start: {
          line: 20,
          column: 31
        },
        end: {
          line: 20,
          column: 67
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 9,
            column: 2
          },
          end: {
            line: 9,
            column: 3
          }
        },
        loc: {
          start: {
            line: 9,
            column: 9
          },
          end: {
            line: 9,
            column: 52
          }
        },
        line: 9
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 10,
            column: 2
          },
          end: {
            line: 10,
            column: 3
          }
        },
        loc: {
          start: {
            line: 10,
            column: 9
          },
          end: {
            line: 10,
            column: 26
          }
        },
        line: 10
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 19,
            column: 2
          },
          end: {
            line: 19,
            column: 3
          }
        },
        loc: {
          start: {
            line: 19,
            column: 9
          },
          end: {
            line: 19,
            column: 55
          }
        },
        line: 19
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 20,
            column: 2
          },
          end: {
            line: 20,
            column: 3
          }
        },
        loc: {
          start: {
            line: 20,
            column: 31
          },
          end: {
            line: 20,
            column: 67
          }
        },
        line: 20
      }
    },
    branchMap: {},
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0
    },
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "b7dbc67a59ddc47d06b83426926cd65cdc3fd5c7"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_eonn68ama = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_eonn68ama();
import { allowedCurrencies, CurrencyType } from 'src/types/currency';
import { createNormalizeChecking } from 'src/utils/create-normalize-checking';
export var checkCurrency = (cov_eonn68ama().s[0]++, createNormalizeChecking(function (v) {
  cov_eonn68ama().f[0]++;
  cov_eonn68ama().s[1]++;
  return "".concat(v).trim().toUpperCase();
}, function (v) {
  cov_eonn68ama().f[1]++;
  cov_eonn68ama().s[2]++;
  return v in CurrencyType;
}, 'The currency parameter has an incorrect value. Please check it', CurrencyType.AED));
export var formatCurrency = (cov_eonn68ama().s[3]++, createNormalizeChecking(function (v) {
  cov_eonn68ama().f[2]++;
  cov_eonn68ama().s[4]++;
  return "".concat(v).trim().toUpperCase();
}, function (v) {
  cov_eonn68ama().f[3]++;
  cov_eonn68ama().s[5]++;
  return allowedCurrencies.includes(v);
}, 'The currency parameter has an incorrect value. Please check it', undefined));